import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessAuditByIdSlice } from './get';

export const coreDataSecurityAccessAuditByIdReducers = combineReducers({
	get: getCoreDataSecurityAccessAuditByIdSlice.asyncReducers
});

export const coreDataSecurityAccessAuditByIdWatchers = combineAllWatchers([
	getCoreDataSecurityAccessAuditByIdSlice.asyncWatchers
]);
